import { render, staticRenderFns } from "./FillClaimTable.vue?vue&type=template&id=3ea0c2a3&scoped=true"
import script from "./FillClaimTable.vue?vue&type=script&lang=js"
export * from "./FillClaimTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ea0c2a3",
  null
  
)

export default component.exports